import styled from "styled-components";
import { Arquivo, BotaoIcone, Conteudo } from "../styles";

export const ContainerVazio = styled(Conteudo)`
    text-align: center !important;
    margin-bottom: 1.5rem !important;
`;

export const IconeDocumentoVazio = styled(BotaoIcone)`
    justify-content: center !important;
    margin-top: 3rem !important;
    margin-bottom: 1.5rem !important;
`;

export const Paragrafo = styled.p`
    color: ${(props: any) => props.theme.colors.interfaceText} !important;
    margin-bottom: 0.5rem !important;
`;

export const ParagrafoMuted = styled.p`
    color: ${(props: any) => props.theme.colors.c64748b} !important;
    margin-bottom: 1.5rem !important;
`;

export const SeloContainer = styled.div`
    margin-bottom: 1.5rem !important;
`;

export const ParagrafoInfo = styled.p`
    color: ${(props: any) => props.theme.colors.interfaceText} !important;
    margin-top: 0.25rem !important;
    margin-bottom: 1rem !important;
    white-space: pre-line !important;
`;

export const ArquivosContainer = styled.div`
    margin-top: 0.5rem !important;
`;

export const ArquivoComMargem = styled(Arquivo)<{ $isExcluido?: boolean }>`
    margin-bottom: 0.5rem !important;
    background-color: ${({ $isExcluido }) => $isExcluido ? 'transparent' : 'var(--cffffff)'} !important;
    
    &:hover {
        background-color: ${({ $isExcluido }) => $isExcluido ? 'transparent' : 'var(--cf8f9fa)'} !important;
    }
`;
